import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

interface EditOptionDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (newName: string) => void;
  optionName: string;
  dialogTitle?: string;
}

const EditOptionDialog: React.FC<EditOptionDialogProps> = ({
  open,
  onClose,
  onSave,
  optionName,
  dialogTitle = "Edit Option",
}) => {
  const [name, setName] = useState(optionName);

  useEffect(() => {
    setName(optionName);
  }, [optionName, open]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Option Name"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          inputProps={{ maxLength: 50 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => onSave(name)}
          variant="contained"
          disabled={!name.trim()}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditOptionDialog;
